import { parseText } from "./nlu";
import { parseWithLLM } from "./llmNLU";
import { fillMissing, followupFor } from "./slotFiller";
import { validateAndNormalize, validateDelete } from "./validator";
import { showGhost, clearGhost, commitRectangle, commitDelete } from "./executor";

const session = { current: null };

export async function handleUserText(text){
  // Parse with BOTH → merge
  let llm = null; try { llm = await parseWithLLM(text); } catch {}
  const rx = parseText(text);

  const intent = (llm?.intent === "draw_rectangle" || rx?.intent === "draw_rectangle")
    ? "draw_rectangle" : (llm?.intent || rx?.intent || "unknown");
  const language = llm?.language || rx?.language || "hinglish";
  const slots = deepMergeSlots(llm?.slots, rx?.slots);
  const parsed = { intent, language, slots };

  // If ongoing, treat any partial info as continuation
  if(session.current){
    session.current.language = session.current.language || language;
    session.current.slots = deepMergeSlots(session.current.slots, parsed.slots);
    return summarizeOrAsk(session.current);
  }

  if(parsed.intent !== "draw_rectangle" && parsed.intent !== "delete_rectangle" && !looksLikeGeom(parsed.slots)){
    return [botMsg(language, 'Samjha nahi. Bolo: "M1 me 2um x 1um 0,0 pe".')];
  }

 session.current = { intent: parsed.intent==="delete_rectangle"?"delete_rectangle":"draw_rectangle", language, slots: parsed.slots };
  return summarizeOrAsk(session.current);
}

export function confirm(){
  if (session.current?.intent === "delete_rectangle") {
    const res = commitDelete(session.current.readyDel);
    const ok = botMsg(session.current.language, `Deleted ${res.count} rectangle(s) ✅`);
    session.current = null;
    return [ok];
  }
  if(!session.current?.ready) return [botMsg(session.current?.language, "Abhi details incomplete hain.")];
  const id = commitRectangle(session.current.ready);
  clearGhost(session.current.previewId);
  const ok = botMsg(session.current.language, `Done ✅ (id: ${id ?? "n/a"})`);
  session.current = null;
  return [ok];
}

/* ───────── helpers ───────── */

function summarizeOrAsk(st){
  // try to auto-fill cell via ProjectManager inside slotFiller
  const missing = fillMissing(st);
  if(missing.length){
    return [followupFor(missing[0], st)];
  }
  try{
   if (st.intent === "delete_rectangle") {
      const readyDel = validateDelete(st);
      st.readyDel = readyDel;
      const summary = summarizeDelete(readyDel, st.language);
      return [botMsg(st.language, summary + "\n\nType 'ok' to delete.")];
    } else {
      const ready = validateAndNormalize(st);
      st.ready = ready;
      const summary = summarize(ready, st.language);
      return [botMsg(st.language, summary + "\n\n'ok' likho to bana du?")];
    }
  }catch(e){
    if(e?.ui) return [followupFor(e.code, st)];
    return [botMsg(st.language, "Kuch galat lag raha hai, dubara clear bolo.")];
  }
}

function deepMergeSlots(a={}, b={}){
  const out = { ...(a||{}), ...(b||{}) };
  out.size = (a?.size || b?.size) ? { ...(a?.size||{}), ...(b?.size||{}) } : undefined;
  out.placement = (a?.placement || b?.placement) ? { ...(a?.placement||{}), ...(b?.placement||{}) } : undefined;
  out.repeat = (a?.repeat || b?.repeat) ? { ...(a?.repeat||{}), ...(b?.repeat||{}) } : undefined;
  return out;
}

function looksLikeGeom(slots){
  return !!(slots?.size || slots?.placement || slots?.layer);
}


function summarizeDelete(o, lang="hinglish"){
  const parts = [];
  parts.push(`Cell ${o.cell}`);
  if (o.layerId) parts.push(`Layer ${o.layerId}`);
  if (o.ids?.length) parts.push(`ids ${o.ids.join(",")}`);
  if (o.selected) parts.push(`selected`);
  if (o.size) parts.push(`size ${o.size.w}×${o.size.h} um`);
  if (o.region) parts.push(`box [${o.region.x1},${o.region.y1}]→[${o.region.x2},${o.region.y2}]`);
  const s = `Delete: ${parts.join(" • ")}`;
  return (lang==="hi") ? `हटाने का सारांश: ${s}` : `Summary: ${s}`;
}

function botMsg(lang, text){ return { role:"assistant", text }; }

function summarize(o, lang="hinglish"){
  const u = o.units || "µm";
  const base = `Cell ${o.cell} | Layer ${o.layerId} | (${fmt(o.x)},${fmt(o.y)}) • ${fmt(o.w)}×${fmt(o.h)} ${u}`;
  const rot = o.rotation ? ` • rot ${o.rotation}°` : "";
  const rep = o.repeat && (o.repeat.nx>1 || o.repeat.ny>1)
    ? ` • repeat ${o.repeat.nx}×${o.repeat.ny} (Δx=${fmt(o.repeat.dx)}, Δy=${fmt(o.repeat.dy)})` : "";
  const txt = base + rot + rep;
  if (lang === "hi") return `सारांश: ${txt}`;
  if (lang === "en") return `Summary: ${txt}`;
  return `Summary: ${txt}`;
}
function fmt(n){ if(typeof n!=="number") return String(n??""); const s=(Math.abs(n)<1e-3||Math.abs(n)>1e4)?n.toExponential(2):n.toFixed(3); return s.replace(/\.?0+e/,"e").replace(/\.?0+$/,""); }

export default { handleUserText, confirm };
